import React, {useEffect, useState} from 'react';
import {Button, Form, FormGroup, Input, Label} from 'reactstrap';
import {doc, updateDoc} from "firebase/firestore";
import {getDb, miniGames} from 'util/Constants';
import CropImage from "../reusable/cropImage"
import imageIcon from "../../assets/img/brand/image1.png"
import {getDownloadURL, getStorage, ref, uploadBytes} from "firebase/storage";


export default function AptitudeModal({isOpen, toggle, item, cognitive, setCognitive}) {
    const [data, setData] = useState({tabName: "Mini 1"});
    const [localImage, setLocalImage] = useState(null);
    const [logo, setLogo] = useState(null);
    const [imageError, setImageError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleSave = async (e) => {
        // // const db = firebase.firestore();
        setLoading(true);
        e.preventDefault();
        const img = await addUrl();
        if (item?.hasOwnProperty('name')) {

            const washingtonRef = doc(getDb(), "Metadata_Games", "cognitive");
            const updatedTodos = cognitive.map(e => {
                if (e.tabName === item?.tabName) {
                    return {
                        ...e,
                        goalText: data?.goalText,
                        name: data?.name,
                        passingScore: data.passingScore,
                        time: data.time,
                        tabName: data.tabName,
                        image: img,
                        // evaluation: data?.evaluation,
                        nbrOfQues: Number(data?.nbrOfQues)
                    };
                }
                return e;
            });
            await updateDoc(washingtonRef, {
                data: updatedTodos
            });
            setCognitive(updatedTodos)
        } else {

            const washingtonRef = doc(getDb(), "Metadata_Games", "cognitive");
            await updateDoc(washingtonRef, {
                data: [...cognitive, {...data, image: img}]
            });
            setCognitive([...cognitive, {...data, image: img}])

        }
        setLoading(false);
        toggle();
    };

    const handleChange = (e) => {
        const {name, value} = e.target;
        setData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    useEffect(() => {

        if (item.name) {
            setData(item);
            setLogo(item?.image)
        }
    }, [item]);

    const addUrl = async () => {

        if (typeof logo === "string" && !logo.includes("firebase")) {

            const _file = await urltoFile(logo, `${data.name + "-" + "cognitive"}logo`, 'image/png');
            const storage = getStorage()
            const imageRef = ref(storage, `${data.name + "-" + "cognitive"}logo`);
            const data1 = await uploadBytes(imageRef, _file);
            const downloadUrl = await getDownloadURL(data1.ref);
            return downloadUrl;
        } else {
            return logo;
        }
    };

    const urltoFile = (url, filename, mimeType) => {
        return (fetch(url)
                .then(function (res) {
                    return res.arrayBuffer();
                })
                .then(function (buf) {
                    return new File([buf], filename, {type: mimeType});
                })
        );
    }
    return (

        <Form onSubmit={handleSave}>
            <FormGroup>
                <Label for="aptitude">Name</Label>
                <Input
                    type="text"
                    name="name"
                    value={data?.name}
                    onChange={handleChange}
                    placeholder="Cognitive"
                    required
                />
            </FormGroup>
            <FormGroup>
                <Label for="tabname">Tab Name</Label>

                <Input type="select" name="tabName" value={data?.tabName}
                       onChange={handleChange}>
                    {miniGames.map(i => (
                        !item?.hasOwnProperty('name') ? !(cognitive.map(d => d.tabName).includes(i.value)) &&
                            <option value={i.value}>{i.label}</option> :
                            <option value={i.value}>{i.label}</option>
                    ))}
                </Input>
            </FormGroup>
            <FormGroup>
                <Label for="tabname">Objective Text</Label>
                <Input
                    type="textarea"
                    name="goalText"
                    value={data?.goalText}
                    onChange={handleChange}
                    placeholder="Objective"
                    required
                />
            </FormGroup>
            <FormGroup>
                <Label for="tabname">Time</Label>
                <Input
                    type="number"
                    name="time"
                    value={data?.time}
                    onChange={handleChange}
                    placeholder="Time"
                    required
                    min={0}
                />
            </FormGroup>
            {/*<FormGroup>*/}
            {/*    <Label for="evaluation">Evaluation</Label>*/}
            {/*    <Input*/}
            {/*        type="text"*/}
            {/*        name="evaluation"*/}
            {/*        value={data?.evaluation}*/}
            {/*        onChange={handleChange}*/}
            {/*        placeholder="Evaluation"*/}
            {/*        required*/}
            {/*    />*/}
            {/*</FormGroup>*/}
            <FormGroup>
                <Label for="nbrOfQues">Number of Questions</Label>
                <Input
                    type="number"
                    name="nbrOfQues"
                    value={data?.nbrOfQues}
                    onChange={handleChange}
                    placeholder="Number of Questions"
                    required
                />
            </FormGroup>
            <FormGroup>
                <Label for="tabname">Passing Score</Label>
                <Input
                    type="number"
                    name="passingScore"
                    value={data?.passingScore}
                    onChange={handleChange}
                    placeholder="Passing Score"
                    required
                    min={0}
                />
            </FormGroup>
            <FormGroup>
                <div
                    className="  d-flex align-items-start justify-content-between">
                    <div>
                        <label className="textColor">Logo</label>
                        <div className="w-75 ">
                            {imageError === "left" &&
                                <p className="text-danger mb-0">Please Select image less than
                                    1mb</p>}
                            <span
                                className="text-secondary">(Image should be 340px x 60px or 17 : 3)</span>
                        </div>
                    </div>
                    <div style={{width: "59%", minHeight: "auto"}}
                         className="imageBg py-1 d-flex justify-content-center">
                        <label className="imageInput leftLogo"
                               role="button">
                            <img src={localImage ? localImage : logo ? logo : imageIcon}
                                 alt=""
                                 height={localImage ? 100 : logo ? 100 : 80}
                                 width={localImage ? 100 : logo ? 100 : 80}
                            />
                            {!logo &&
                                <span
                                    className={`ms-4 ${!logo && 'text-muted'}`}>{!logo && "Upload"}</span>
                            }
                            <CropImage aspectRatio={1} stateSetImage={setLogo} setError={setImageError}
                                       imageLocation="left"
                                       setLocal={setLocalImage}/>
                        </label>
                    </div>
                </div>
            </FormGroup>
            <Button color="primary" type='submit' disabled={loading}>
                {loading ? <>
                                    <span className="spinner-border spinner-border-sm" role="status"
                                          aria-hidden="true"></span>
                    <span className="sr-only">Loading...</span>
                </> : "Save"}
            </Button>
            <Button color="secondary" onClick={toggle} disabled={loading}>
                Cancel
            </Button>
        </Form>
    );
}
